// src/pages/Sniper/components/InfoBox.tsx
import React from "react";
import cn from "classnames";

interface WalletBoxProps {
    label: string;
    value: string | number;
    className?: string; // Allow passing extra classes
}

const WalletBox: React.FC<WalletBoxProps> = ({ label, value, className }) => {
    return (
        <div
            className={cn(
                "bg-card border border-card-foreground rounded-xl p-3 flex-1  gap-2 flex justify-between",
                className,
            )}
        >
            <div className="text-accent text-sm h-fit">{label}</div>
            <div className="text-gray-300 text-sm">{value}</div>
        </div>
    );
};

export default WalletBox;
